import axios from "axios";
import { formatDateOnly } from '../components/Utils';

export const designerAvailabilitiesPath = (calendar, designer, weekStart) => {
  const date = weekStart ? formatDateOnly(weekStart) : null;
  let paramsPart = weekStart ? `?date=${date}` : '';
  paramsPart = designer && designer.id ? `${paramsPart}&designer_id=${designer.id}` : paramsPart;
  return `/design/calendars/${calendar.id}/availabilities${paramsPart}`;
};

export const loadAvailabilities = (calendar, designer, weekStart, onSuccess, onError) => {
  const data = {};
  axios
    .get(designerAvailabilitiesPath(calendar, designer, weekStart, data))
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};




// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/api/AdminAvailabilitiesApi.js